import _ from 'lodash'

export const remove_wheel_columns = []

export function group_wheels(wheels){
	if( wheels && wheels.length ){
		//console.log(wheels)
		var wheel_groups = _.groupBy(wheels, x => {
			//console.log( x )
			return x.model + '|' + x.finish
		})
		var grouped_wheels = _.values(wheel_groups).map( group => {
			let sizes = _.map(group, x => {
				return { item_num: x.item_num, size: x.diameter, width: x.width, offset: x.offset }
			})
			sizes = _.uniqWith( sizes, _.isEqual)
			let result = _.assign({}, group[0])
			remove_wheel_columns.forEach( col => { delete result[col] })
			result.sizes = sizes
			return result
		})
		return grouped_wheels
	}else{
		//console.log('No wheels to group.')
		return []
	}
}

const FILTER_REGEXP =  /^([a-zA-Z0-9_\w]*)\|(.*)$/ig // matches 'width|8', etc

/*
 * Returns a boolean (true/false) whether or not the wheel matches the filters
 */
export function does_wheel_match_filter(wheel, filters){
	let ok = true
	for( let i = 0; i < filters.length; i++ ){
		let filter = filters[i]
		if( _.isFunction(filter) ){
			ok = ok && filter(wheel)
		}else if( _.isObject(filter) ){
			/* eslint-disable no-loop-func */
			Object.keys(filter).forEach( key => {
				if( !_.isBoolean(filter[key]) && !isNaN(filter[key]) ){
					filter[key] = Number(filter[key])
				}
				if( !_.isBoolean(wheel[key]) && !isNaN(wheel[key]) ){
					wheel[key] = Number(wheel[key])
				}
				// eslint-disable-next-line
				ok = ok && (filter[key] == wheel[key])
			})
			/* eslint-enable no-loop-func */
		}else if( _.isString(filter) ){
			let filter_match_string = FILTER_REGEXP.exec(filter)
			if( filter_match_string ){
				let filter_key = filter_match_string[1],
					filter_value = filter_match_string[2]
				ok = ok && (String(filter_value) === String(wheel[filter_key]))
			}
		}

		// If does not match, then stop looking at other filters
		if( !ok ){
			return false
		}
	}
	return ok
}
